"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _types = require("./types");

Object.keys(_types).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _types[key];
    }
  });
});

var _timestamp = require("./timestamp");

Object.keys(_timestamp).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _timestamp[key];
    }
  });
});

var _dispatchPromise = require("./dispatch-promise");

Object.defineProperty(exports, "dispatchPromise", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_dispatchPromise).default;
  }
});
exports.logged = logged;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var selectWithProps = exports.selectWithProps = function selectWithProps(selector, extraProps) {
  return function (state, props) {
    return selector(state, _extends({}, props, extraProps));
  };
};
function logged() {
  for (var _len = arguments.length, mess = Array(_len), _key = 0; _key < _len; _key++) {
    mess[_key] = arguments[_key];
  }

  // a `=>` function here messes up atom's syntax highlighting for some reason
  return function (val) {
    var _console;

    (_console = console).log.apply(_console, mess.concat([val]));
    return val;
  };
}

// quickly disable a log-wrapper with an x, like with unittests
var xlogged = exports.xlogged = function xlogged() {
  return function (val) {
    return val;
  };
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ../core/lib/selectors/util/index.js
// module id = 13
// module chunks = 0